import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
/*App imports*/
import { HelpersService } from '../../../../services/tools/helpers.service';
import { CreditosService } from "../../../../services/creditos.service";
import { CreditosHipotecariosService } from "../../../../services/creditos-hipotecarios.service";

@Component({
  selector: 'capacidad-pago',
  templateUrl: './capacidad-pago.component.html',
  styleUrls: ['./capacidad-pago.component.scss']
})
export class CapacidadPagoComponent implements OnInit {

    @Input() public idCreditos: number = null;
    @Input() public isEditable: boolean = false;

    public hipotecario : any = {};
    public prestamo : any = {};
    public simuladorLink : string = '/creditos/hipotecario/simulacion/'; 
    private isInitialized : boolean = false;

    constructor(
      private helperService : HelpersService,
      private creditosService : CreditosService,
      private hipotecariosService : CreditosHipotecariosService
    ){
    }

    ngOnInit() {
    }

    public loadComponent(){
      if(!this.isInitialized){
        this.simuladorLink +=  this.idCreditos;
        this.getCredito(this.idCreditos);   
        this.isInitialized = true; 
      }
    }

    getCredito(idCredito: number){

      let credito = { prestamo : null };
      this.creditosService.get(idCredito).switchMap(
        data => {
          // do something with your data
          credito = data.json().content;
          return this.hipotecariosService.getCreditoHipotecario(idCredito); // use it for example in your http request
        }
      ).subscribe(
        hipotecarioData => {
          this.prestamo = credito.prestamo;
  
          //Handle hipotecario data
          const arrayCreditosHipotecario = hipotecarioData.json().content;
          if(arrayCreditosHipotecario.length > 0){
            this.hipotecario = arrayCreditosHipotecario[0];
          }
        }
        , error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
  
            if(error.status == 400) {
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }  
      );
  
    }
}



// WEBPACK FOOTER //
// ./src/app/creditos/hipotecario/detalles/components/capacidad-pago.component.ts